export default "__VITE_ASSET__BxqNxCRn__"